import type {
	ConfluenceSpace,
	KnowledgeCommonFlagMessage,
	Flag,
	FlagData,
	Category,
	CategoryGuid,
} from '../../../common/types';
import { getCommonFlagData } from '../../../common/utils';
import type {
	ImmutableState,
	LoadingData,
	UserCapabilitiesData,
	RedirectionData,
	CategoriesState,
	CreateCategoryState,
} from '../types';
import { findCategory } from '../utils';

export const getIsPublished = ({ published }: ImmutableState): boolean => published;

export const getDraftShareId = ({ draftShareId }: ImmutableState): string => draftShareId;

export const getArticleId = ({ articleId }: ImmutableState): string => articleId;

export const getIsFetchingDraftDetails = ({ isFetchingDraftDetails }: ImmutableState): boolean =>
	isFetchingDraftDetails;

export const getRedirectionData = (state: ImmutableState): RedirectionData => state.redirectionData;

export const getPermittedSpaces = (state: ImmutableState): LoadingData<ConfluenceSpace[]> =>
	state.spacesPermitted;

export const getLinkedSpaces = (state: ImmutableState): LoadingData<ConfluenceSpace[]> =>
	state.linkedSpaces;

export const getUserCapabilities = (state: ImmutableState): UserCapabilitiesData =>
	state.userCapabilities;

export const getCategoriesData = (state: ImmutableState): CategoriesState => state.categoriesData;

export const getCreateCategoryData = (state: ImmutableState): CreateCategoryState =>
	state.createCategoryData;

export const getCategory = (
	state: ImmutableState,
	categoryId: CategoryGuid,
): Category | undefined => findCategory(state.categoriesData, categoryId);

export const getCommonFlags = ({ flags }: ImmutableState): Flag[] => flags;

export const getKnowledgeCommonFlags = (
	state: ImmutableState,
	messages: KnowledgeCommonFlagMessage,
): FlagData => getCommonFlagData({ ...state }, messages);
